/**
 * Nominatim (OpenStreetMap) 리버스 지오코딩 API
 * 해외 좌표의 주소를 조회하는데 사용
 */

export interface NominatimResponse {
  place_id: number;
  licence: string;
  osm_type: string;
  osm_id: number;
  lat: string;
  lon: string;
  display_name: string;
  address: {
    road?: string;
    suburb?: string;
    city?: string;
    state?: string;
    postcode?: string;
    country?: string;
    country_code?: string;
  };
  boundingbox: string[];
}

/**
 * Nominatim 검색 결과
 */
export interface NominatimSearchResult {
  place_id: number;
  licence: string;
  osm_type: string;
  osm_id: number;
  lat: string;
  lon: string;
  display_name: string;
  address?: {
    road?: string;
    suburb?: string;
    city?: string;
    state?: string;
    postcode?: string;
    country?: string;
    country_code?: string;
  };
  boundingbox: string[];
}

/**
 * Nominatim을 사용한 장소 검색
 * @param query 검색어
 * @returns 검색 결과 목록
 */
export const searchNominatim = async (
  query: string
): Promise<NominatimSearchResult[]> => {
  try {
    const response = await fetch(
      `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(
        query
      )}&limit=10&accept-language=ko`,
      {
        headers: {
          "User-Agent": "NongCall-Web/1.0", // Nominatim은 User-Agent 필수
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Nominatim API error: ${response.status}`);
    }

    const data: NominatimSearchResult[] = await response.json();
    return data;
  } catch (error) {
    console.error("Nominatim search error:", error);
    return [];
  }
};

/**
 * Nominatim을 사용한 리버스 지오코딩
 * @param lat 위도
 * @param lng 경도
 * @returns 주소 문자열
 */
export const getNominatimAddress = async (
  lat: number,
  lng: number
): Promise<string> => {
  try {
    const response = await fetch(
      `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}&accept-language=en`,
      {
        headers: {
          "User-Agent": "NongCall-Web/1.0", // Nominatim은 User-Agent 필수
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Nominatim API error: ${response.status}`);
    }

    const data: NominatimResponse = await response.json();

    // 주소 포맷팅
    return data.display_name || "주소를 찾을 수 없습니다";
  } catch (error) {
    console.error("Nominatim reverse geocoding error:", error);
    return "주소 조회 실패";
  }
};

